// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 240) return "static/chunks/c36f3faa-7777885e32ca33e0.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"61231d388644c421","2931":"b7a014d240f3dca8","4316":"890f6f4190c9fdfb","5414":"69bcfe021d6995dd","7161":"327e9675dc0f25eb"}[chunkId] + ".js";
};